"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractTaskManager = void 0;
const task_1 = require("./task");
class AbstractTaskManager {
    constructor(addons) {
        this.runningTasks = new Map();
        this.addons = addons || [];
    }
    runTask(task) {
        return __awaiter(this, void 0, void 0, function* () {
            const { taskId } = task.passport;
            this.runningTasks.set(taskId, task);
            const taskExecutionResult = yield task.run();
            this.runningTasks.delete(taskId);
            return taskExecutionResult;
        });
    }
    createFlow(steps) {
        return (passport) => __awaiter(this, void 0, void 0, function* () {
            const task = new task_1.Task(steps, passport, this.addons);
            return this.runTask(task);
        });
    }
    cancel(taskId, reason) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = this.runningTasks.get(taskId);
            if (task) {
                yield task.cancel(reason);
            }
        });
    }
}
exports.AbstractTaskManager = AbstractTaskManager;
//# sourceMappingURL=task-manager.js.map